import { Link } from 'react-router'
import { STATES } from '../content/states'

const featuredGuides = [
  { to: '/guides/government-bid-checklist', label: 'Bid submission checklist' },
  { to: '/guides/how-to-read-a-bid-package', label: 'Reading a bid package' },
]

/** Public-resources bridge: connects the marketing homepage to the crawlable
 * public bid inventory on the app and the state/guide directories, so visitors
 * and crawlers can reach current opportunities before any registration ask. */
export default function PublicResourcesSection() {
  return (
    <section className="relative py-20 bg-[#0d1117] border-b border-white/[0.05]">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="max-w-[720px] mb-8">
          <span className="text-xs font-mono uppercase tracking-[0.1em] text-[#06b6d4]">Public resources</span>
          <h2 className="mt-3 text-[clamp(24px,2.4vw,34px)] font-semibold tracking-[-0.02em] text-white">
            Look before you sign up
          </h2>
          <p className="mt-4 text-[16px] leading-[1.7] text-[#9ca3af]">
            You can browse current public opportunities across New England before registering — no account required.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          <a
            href="https://app.procuralerts.com/bids"
            className="rounded-xl border border-[#06b6d4]/40 bg-[#06b6d4]/[0.06] p-5 hover:border-[#06b6d4] transition-colors"
          >
            <h3 className="text-base font-semibold text-white">Browse Live Bids</h3>
            <p className="mt-2 text-sm leading-[1.6] text-[#9ca3af]">The current public inventory, collected daily from official sources.</p>
          </a>
          <Link
            to="/government-bids"
            className="rounded-xl border border-white/[0.08] bg-white/[0.025] p-5 hover:border-[#06b6d4]/50 transition-colors"
          >
            <h3 className="text-base font-semibold text-white">Government Bids by State</h3>
            <p className="mt-2 text-sm leading-[1.6] text-[#9ca3af]">What ProcurAlerts monitors in each New England state.</p>
          </Link>
          <Link
            to="/guides"
            className="rounded-xl border border-white/[0.08] bg-white/[0.025] p-5 hover:border-[#06b6d4]/50 transition-colors"
          >
            <h3 className="text-base font-semibold text-white">Government Contracting Guides</h3>
            <p className="mt-2 text-sm leading-[1.6] text-[#9ca3af]">Plain-language introductions to public bidding.</p>
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          {STATES.map((state) => (
            <Link
              key={state.slug}
              to={`/government-bids/${state.slug}`}
              className="border border-white/[0.1] rounded-lg px-3 py-2 text-sm text-[#9ca3af] hover:text-[#06b6d4] hover:border-[#06b6d4]/40"
            >
              {state.name}
            </Link>
          ))}
          {featuredGuides.map((guide) => (
            <Link
              key={guide.to}
              to={guide.to}
              className="border border-white/[0.1] rounded-lg px-3 py-2 text-sm text-[#9ca3af] hover:text-[#06b6d4] hover:border-[#06b6d4]/40"
            >
              {guide.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
